<!-- app/components/Header/Right/index.vue -->
<template>
  <div class="flex flex-row gap-2 ml-auto">

    <!-- Botão para abrir o Modal para Login ou Cadastro de Usuário -->
    <AuthLoginButton v-if="!userStore.isLoggedIn" :text-class="textClass"/>
    <!-- Quando o usuário estiver logado, visualiza ícones de mensagens e notificações e o Menu do Usuário -->
    <div v-if="userStore.isLoggedIn" class="flex items-center gap-6">
      <HeaderRightNotificacaoMenu :icon-class="textClass"/>
      <HeaderRightMenssagemMenu :icon-class="textClass"/>
      <HeaderRightUserMenu v-if="props.showUserMenu" :icon-class="textClass"/>
    </div>

    <USeparator orientation="vertical" :class="['h-10 mx-2', textClass]" size="xs"/>

    <!-- Abrir modal para Busca Textual por cursos -->
    <HeaderRightSearch :variant="variant"/>
  </div>
</template>
<script setup lang="ts">
const userStore = useUserStore()

const props = defineProps<{
  variant: 'primaria' | 'secundaria';
  showUserMenu: boolean;
}>()

const isPrimaria = computed(() => props.variant === 'primaria')

const textClass = computed(() =>
    isPrimaria.value ? 'text-white' : 'text-gray-700'
)
</script>